import i18n from 'i18next';

export function formatError(result) {
    if (result.data && Array.isArray(result.data)) {
        return result.data.map((error) => {
            const [field, message] = error.split(":").map((item) => item.trim());
            const fieldName = field.replace(/Id$/, "");
            //${i18n.t(`backend.${message}`)}`
            return `${i18n.t(`columns.${fieldName}`)}: ${message}`;
        }).join("\n");
    }

    if (result.message) {
        // return i18n.t("backend." + result.message);
        return result.message;
    }
    if (!result.error) {
        return i18n.t("backend.unknownError");
    }

    return i18n.t("backend." + result.error);
}

export function formatBackendError(result) {
    if (result.message) {
        return i18n.t("backend." + result.message);
    }
    if (!result.error) {
        return i18n.t("backend.unknownError");
    }
    return result.error;
}

export function hasError(result) {
    return result.error !== "OK";
}
